import { observer } from 'mobx-react'
import { useContext, useEffect } from 'react'
import { LoadingSpinner } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { API_URL, AGE_VERIFICATION_SERVICE_PATH } from '@/constants/apiUrl'
import { forceRedirect } from '@/methods/forceRedirect'

export const AgeVerificationStatusPage = observer(() => {
  const store = useContext(StoreContext)

  useEffect(() => {
    store.InterfaceState.setSendBeforeunloadEvent(false)
    // The BE completes the transaction and redirects back to the
    // /age-verification-complete screen with the result in query params
    forceRedirect(`${API_URL}/${AGE_VERIFICATION_SERVICE_PATH}/complete`)
  }, [])

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <LoadingSpinner />
    </div>
  )
})
